import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { Card, CardContent } from '../components/ui/card';
import { useSiteData } from '../contexts/SiteDataContext';

const CategoriesPage = () => {
  const navigate = useNavigate();
  const { categories } = useSiteData();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <section className="bg-gradient-to-r from-[#055509] to-[#0a7a0f] text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Categorias de Produtos</h1>
          <p className="text-xl text-gray-200">Navegue por categorias e encontre exatamente o que precisa</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories.map((category) => {
              const IconComponent = LucideIcons[category.icon] || LucideIcons.Box;
              return (
                <Card key={category.id || category.slug} className="group cursor-pointer hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-[#FFB025] overflow-hidden" onClick={() => navigate(`/categorias/${category.slug}`)}>
                  <CardContent className="p-8">
                    <div className="w-20 h-20 mb-6 bg-gradient-to-br from-[#055509] to-[#0a7a0f] rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                      <IconComponent className="text-[#FFB025]" size={40} />
                    </div>
                    <h3 className="text-2xl font-bold text-[#055509] mb-3 group-hover:text-[#FFB025] transition-colors">{category.name}</h3>
                    <p className="text-gray-600 mb-4 leading-relaxed">{category.description}</p>
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                      <span className="text-sm font-semibold text-[#FFB025]">{category.productCount} produtos</span>
                      <LucideIcons.ArrowRight className="text-[#055509] group-hover:translate-x-1 transition-transform" size={20} />
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default CategoriesPage;
